import React from 'react';
import SchoolOutlinedIcon from '@mui/icons-material/SchoolOutlined';
import { Card, CardActionArea, CardContent, Typography } from '@mui/material';
import { MOBILE_DENSITY } from '../theme/mobileDensity';

export default function RaTrainingTile({ onOpen, compact = false }: { onOpen: () => void; compact?: boolean }) {
  return <Card variant="outlined" sx={{ height: '100%', minWidth: 0, scrollSnapAlign: 'start',
    borderColor: 'primary.main', bgcolor: 'action.hover',
    '&:hover': { boxShadow: 3 }, '&:focus-within': { borderColor: 'primary.main' } }}>
    <CardActionArea aria-label="Warfighter Training" onClick={onOpen} sx={{ height: '100%',
      p: { xs: MOBILE_DENSITY.cardInset, sm: 2 },
      py: compact ? undefined : { xs: 1.5, sm: 3 },
      minHeight: compact ? { xs: 128, sm: 156 } : MOBILE_DENSITY.touchTarget,
      '&:focus-visible': { outline: '3px solid', outlineColor: 'primary.main', outlineOffset: -3 } }}>
      <CardContent sx={{ display: 'flex', flexDirection: 'column', alignItems: compact ? 'flex-start' : 'center',
        justifyContent: 'center', textAlign: compact ? 'left' : 'center', gap: { xs: 1, sm: 1.5 },
        px: compact ? 0 : 1, py: 0, minHeight: compact ? undefined : { xs: 112, sm: 160 },
        '&:last-child': { pb: 0 } }}>
        <SchoolOutlinedIcon color="primary" sx={{ fontSize: compact ? 28 : { xs: 60, sm: 84 } }} />
        <Typography component="h3" variant={compact ? 'h5' : 'h4'} sx={{ lineHeight: 1.2 }}>Warfighter Training</Typography>
      </CardContent>
    </CardActionArea>
  </Card>;
}
